function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel1CircleAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 8,
      fill: "#28B869",
      stroke: "#ffffff"
    },
    cx: 60,
    cy: 60,
    r: 50
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel1CircleAvailable);
export default __webpack_public_path__ + "static/media/place_model-1_circle_available.1273260ed8b72c378892b1a648023013.svg";
export { ForwardRef as ReactComponent };